module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Medium.0609fff.ttf";